import { PAUSE_INSIDER_MEMBERSHIP_ENABLED } from "@faire/web-api/indigofair/settings/PAUSE_INSIDER_MEMBERSHIP_ENABLED";

import {
  assignSetting,
  getSettingValueWithoutAssignment,
} from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingPauseInsiderMembershipEnabled = (): boolean =>
  getSettingValueWithoutAssignment(PAUSE_INSIDER_MEMBERSHIP_ENABLED, false);

export const assignSettingPauseInsiderMembershipEnabled = async () =>
  assignSetting(PAUSE_INSIDER_MEMBERSHIP_ENABLED);
